import toTitleCase from '@smart-tv/utils/string/to-title-case';
import getDay from '../get-day/get-day';

export const NAMES = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
export const ABBREVIATED_NAMES = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];

export const getDayName = (
  date: Date | number,
  options?: { titleCase?: boolean; abbreviate?: boolean }
): string => {
  const day = getDay(date);
  const name = options?.abbreviate ? ABBREVIATED_NAMES[day] : NAMES[day];

  return options?.titleCase ? toTitleCase(name) : name;
};

export default getDayName;
